module.exports = __webpack_public_path__ + "static/img_0865-5c681412065e76d06dd24059fa39f39b.webp";